import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, Printer, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const telechargerMandat = async (url, headers, nom) => {
  try {
    const r = await axios.get(`${API}${url}?download=true`, { headers, responseType: 'blob' });
    const href = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = href;
    a.download = nom;
    a.click();
    setTimeout(() => URL.revokeObjectURL(href), 2000);
  } catch {
    toast.error('Téléchargement du mandat impossible');
  }
};

/** Aperçu PDF d'un mandat SEPA dans une fenêtre, avec Télécharger / Imprimer. */
export const MandatPdfApercu = ({ mandat, url, headers, onClose }) => {
  const [src, setSrc] = useState(null);
  const nom = mandat ? `Mandat_SEPA_${mandat.rum}${mandat.status === 'signe' ? '' : '_NON_SIGNE'}.pdf` : '';

  useEffect(() => {
    if (!mandat) return undefined;
    let href;
    setSrc(null);
    axios.get(`${API}${url}`, { headers, responseType: 'blob' })
      .then((r) => { href = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })); setSrc(href); })
      .catch(() => { toast.error('Aperçu du mandat impossible'); onClose(); });
    return () => href && URL.revokeObjectURL(href);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mandat?.id]);

  const imprimer = () => {
    const f = document.getElementById('mandat-pdf-frame');
    try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(src, '_blank'); }
  };

  return (
    <Dialog open={!!mandat} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl w-[95vw]" data-testid="mandat-apercu-dialog">
        <DialogHeader>
          <DialogTitle className="flex flex-wrap items-center gap-3 pr-6">
            <span data-testid="mandat-apercu-titre">Mandat SEPA {mandat?.rum}</span>
            <span className="ml-auto flex gap-2">
              <Button size="sm" variant="outline" onClick={imprimer} disabled={!src} data-testid="mandat-apercu-imprimer">
                <Printer className="h-4 w-4 mr-1" /> Imprimer
              </Button>
              <Button size="sm" className="bg-[#0a3d62] hover:bg-[#0c4a78] text-white" onClick={() => telechargerMandat(url, headers, nom)} data-testid="mandat-apercu-telecharger">
                <Download className="h-4 w-4 mr-1" /> Télécharger
              </Button>
            </span>
          </DialogTitle>
        </DialogHeader>
        {src ? (
          <iframe id="mandat-pdf-frame" title="Mandat SEPA" src={src} className="w-full h-[75vh] rounded border" data-testid="mandat-apercu-frame" />
        ) : (
          <div className="h-[75vh] flex items-center justify-center text-slate-500" data-testid="mandat-apercu-loading">
            <Loader2 className="h-6 w-6 animate-spin mr-2" /> Chargement du mandat…
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
